"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _react = _interopRequireWildcard(require("react"));
var _DiscountPurchaseCard = _interopRequireDefault(require("../DiscountPurchaseCard"));
var _DiscountPurchaseModel = _interopRequireDefault(require("../DiscountPurchaseModel"));
var _FreeWithCredit = _interopRequireDefault(require("../FreeWithCredit"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof3(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
/* eslint-disable react/prop-types */

var MixDiscountPurchaseCard = function MixDiscountPurchaseCard(props) {
  var style = props.style,
    flexTitle = props.flexTitle,
    headConfig = props.headConfig,
    onCardChangeTime = props.onCardChangeTime,
    onCardChangeResouse = props.onCardChangeResouse,
    onModelChange = props.onModelChange,
    onNormalNumChange = props.onNormalNumChange,
    onNormalBuyClick = props.onNormalBuyClick,
    onFreeBuyClick = props.onFreeBuyClick,
    onModelOk = props.onModelOk,
    onModelClose = props.onModelClose,
    updateCard = props.updateCard,
    updateSdkAppInfo = props.updateSdkAppInfo,
    cardItem = props.configuration,
    modelText = props.modelText,
    colorTheme = props.colorTheme,
    layoutMode = props.layoutMode,
    sdkAppInfos = props.sdkAppInfos,
    onCardChangeSdkAppId = props.onCardChangeSdkAppId;
  var _a = (0, _react.useState)(false),
    isModalVisible = _a[0],
    setModalVisible = _a[1];
  var _b = (0, _react.useState)(modelText),
    modelData = _b[0],
    setModelData = _b[1];
  var handleOk = function handleOk(data) {
    onModelOk(data, handleCancel);
  };
  var handleCancel = function handleCancel() {
    setModalVisible(false);
    onModelClose(); // 触发关闭
  };
  var _c = (0, _react.useState)(0),
    cardIndex = _c[0],
    setCardIndex = _c[1];
  var _d = (0, _react.useState)({}),
    selectProduce = _d[0],
    setSelectProduce = _d[1];
  var setModalVisibleData = function setModalVisibleData(cardIndex, selectedProduce, cardData) {
    setCardIndex(cardIndex);
    setModalVisible(true);
    setSelectProduce(selectedProduce);
    setModelData(__assign(__assign({}, modelData), cardData));
  };
  (0, _react.useEffect)(function () {
    setModelData(modelText);
  }, [modelText]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "mix-discount-purchase-card",
    style: (0, _typeof2["default"])(style) === 'object' ? style : {}
  }, flexTitle && /*#__PURE__*/_react["default"].createElement(_FreeWithCredit["default"], {
    flexTitle: flexTitle,
    configuration: headConfig
  }), cardItem.length > 0 && ( /*#__PURE__*/_react["default"].createElement(_DiscountPurchaseCard["default"], {
    flexTitle: flexTitle,
    configuration: cardItem,
    updateCard: updateCard,
    updateSdkAppInfo: updateSdkAppInfo,
    onClick: setModalVisibleData,
    onCardChangeTime: onCardChangeTime,
    colorTheme: colorTheme,
    onNormalNumChange: onNormalNumChange,
    modelText: modelData,
    onNormalBuyClick: onNormalBuyClick,
    onFreeBuyClick: onFreeBuyClick,
    onCardChangeResouse: onCardChangeResouse,
    layoutMode: layoutMode,
    sdkAppInfos: sdkAppInfos,
    onCardChangeSdkAppId: onCardChangeSdkAppId
  })), cardItem.length > 0 && ( /*#__PURE__*/_react["default"].createElement(_DiscountPurchaseModel["default"], {
    data: cardItem[cardIndex],
    modelText: modelData,
    selectProduce: selectProduce,
    visible: isModalVisible,
    onOk: handleOk,
    onCancel: handleCancel,
    onModelChange: onModelChange,
    colorTheme: colorTheme
  })));
};
var _default = exports["default"] = MixDiscountPurchaseCard;